import * as React from 'react'
import { trackPaywallEvent } from './usePaywallStore'

// Every funnel event carries the paywall code that brought the visitor here,
// so each step breaks down by quota the same way paywall_hit does.
export function useUpgradeFunnel({
    reasonCode,
    mode,
    selectedPlan,
    period,
    billingSettled,
}) {
    const funnelCode = reasonCode || (mode === 'change' ? 'CHANGE_PLAN' : 'MENU')
    const track = (event, overrides = {}) =>
        trackPaywallEvent(event, {
            code: funnelCode,
            plan: selectedPlan && selectedPlan.planId,
            period,
            mode,
            ...overrides,
        })

    // Waits for /billing/config: only then is it known whether this visit is a
    // purchase or a plan change.
    const trackedRef = React.useRef(false)
    React.useEffect(() => {
        if (trackedRef.current || !selectedPlan || !billingSettled) return
        trackedRef.current = true
        track('upgrade_started', { trigger: reasonCode ? 'paywall' : 'page' })
    }, [selectedPlan, billingSettled])

    return { funnelCode, track }
}
